import {
    Alert,
    Box,
    Typography
} from '@mui/material';

import { MessageSeverityEnum } from '../../../_common/enum/messageSeverity.enum';
import { useAuctionMessage } from '../../../_hubs/auctionMessage.hub';
import { accountService } from '../../../_services/accounts.service';
import { auctionMessageService } from '../../../_services/auctionMessage.service';
import { handleErrorResponse } from '../../../_helpers/handleResponse.helper';

export function AuctionMessages(params: { catalogueId?: number }) {

    const { messages, connected } = useAuctionMessage(params.catalogueId);

    function deactivate(m: any) {
        auctionMessageService.disable(m.id).then(() => { }, handleErrorResponse)
    }

    const messageSx = {
        fontSize: 16,
        fontWeight: 600,
        '& .MuiAlert-message': { fontSize: 16, fontWeight: 600, py: 0.5 },
        '& .MuiAlert-icon': { fontSize: 24 }
    };

    function getMessage(m: any) {
        let _message = "[#" + (m.userName ? m.userName : "ALL") + "]: " + m.message;

        var _m =
            m.messageSeverityId === MessageSeverityEnum.Success ? <Alert sx={messageSx} variant="outlined" severity='success' onClose={accountService.isAdmin ? () => { deactivate(m) } : undefined}>{_message}</Alert> :
                m.messageSeverityId === MessageSeverityEnum.Warning ? <Alert sx={messageSx} variant="outlined" severity='warning' onClose={accountService.isAdmin ? () => { deactivate(m) } : undefined}>{_message}</Alert> :
                    m.messageSeverityId === MessageSeverityEnum.Error ? <Alert sx={messageSx} variant="outlined" severity='error' onClose={accountService.isAdmin ? () => { deactivate(m) } : undefined}>{_message}</Alert> :
                        <Alert icon={false} variant="outlined" sx={{ ...messageSx, "border": "none" }} severity='info' onClose={accountService.isAdmin ? () => { deactivate(m) } : undefined}>{_message}</Alert>;

        //<p style={{ margin: "0px" }}>{_message}</p>;

        return <>{_m}</>;
    }

    return (
        <div style={{
            height: "calc(50vh - 150px)",
            // direction: "rtl", 
            marginTop: "8px", padding: "4px", overflowY: "auto"
        }}>

            {(!messages || !messages.length) &&
                <Box display="flex" alignItems="center" justifyContent="center" sx={{ p: 0, textAlign: "center", marginTop: "8px" }}>
                    <Typography color="text.secondary" fontStyle="italic">
                        {"No auction messages"}
                    </Typography>
                </Box>
            }

            {(!!messages && !!messages.length) && messages.map((m: any) =>
                <div style={{ "width": "100%", direction: "ltr", marginTop: "8px" }}>
                    {getMessage(m)}
                </div>
            )}
        </div>
    )
}
